import { Button, Clickable, Col, Input, Text } from 'components';
import { Api, theme, validateEmail } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = ({ email, setEmail, setResetStep }) => {
  const { isMobile, language } = useSelector((state) => state.appState),
    user = useSelector((state) => state.user),
    disabled = !validateEmail(email),
    navigate = useNavigate(),
    { t } = useTranslation();

  async function sendRecovery() {
    /**
     * @property {boolean} noUserFound
     */
    const res = await Api.post('/users/forgotPassword', { email, lang: language }, 'sendRecovery');
    if (!res) return;

    if (res.noUserFound) return setResetStep('NoUserFound');
    setResetStep('Confirmation');
  }

  return (
    <Col marg="28px 0 0" center noFlex wid="100%">
      <Text h1 center>
        {t('forgotPassword.passwordReset')}
      </Text>

      {/*
        `Text` treats any `wid` as a single truncated line (nowrap + ellipsis), so at 456px the
        instructions were cut off mid-sentence. `whiteSpace="normal"` is emitted after that rule
        and lets the sentence wrap inside the same width.
      */}
      <Text
        col={theme.GREY_60}
        marg="8px"
        center
        wid={isMobile ? 'calc(100vw - 16px)' : '456px'}
        whiteSpace="normal"
      >
        {t('forgotPassword.enterEmail')}
      </Text>

      <Col center>
        <Input
          marg="32px 0 0"
          wid="296px"
          placeholder={t('common.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={user?._id}
        />

        <Button
          marg="28px 0 0"
          wid="296px"
          disabled={disabled}
          text={t('forgotPassword.sendRecovery')}
          bg={theme.SECONDARY}
          app
          onClick={sendRecovery}
          action="sendRecovery"
        />
      </Col>

      <Clickable
        onClick={() => {
          navigate('/login');
        }}
        marg="27px 0 0"
      >
        <Text b2 center bold>
          {t('forgotPassword.backToLogin')}
        </Text>
      </Clickable>
    </Col>
  );
};

export default ForgotPassword;
